import React, {useState, useEffect, useRef} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Link } from 'react-router-dom';
import { Row, Col, Container, Card, CardBody, CardTitle, Modal, Form, Label, Input, Badge, UncontrolledDropdown } from "reactstrap"



import axios from 'axios';
import * as url from 'helpers/url_helper';
import * as be from 'helpers/backend_helper';
import { Config, TOAST_OPTIONS, formatDate } from 'helpers/backend_helper';
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import { Button,  DropdownToggle,  DropdownMenu,  DropdownItem,  ButtonDropdown, Table} from "reactstrap";
import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader'
import Select from "react-select"
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import { useHistory } from 'react-router-dom';

import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, {Search} from 'react-bootstrap-table2-toolkit';

import paginationFactory, {
    PaginationListStandalone,
    PaginationProvider,
  } from "react-bootstrap-table2-paginator";

    const Attendance = () => {
        
        const history = useHistory();
        toastr.options = TOAST_OPTIONS;
        const [isLoading, setIsLoading] = useState(false)

        const [selectedEmployee, setSelectedEmployee] = useState(null)
        const [employeeId, setEmployeeId] = useState('')
        const [attendanceDate, setAttendanceDate] = useState('')
        const [status, setStatus] = useState('')
        const [aDate, setADate] = useState([])
        const [id, setId] = useState('')


        const [sStartDate, setSStartDate] = useState([new Date(new Date().getFullYear(), 0, 1)]);
        const [sEndDate, setSEndDate] = useState([new Date(new Date().getFullYear(), 11, 31)]);
        const [sEmployeeName, setSEmployeeName] = useState('')  
        const [sDeptId, setSDeptId] = useState('')
        const [sLocationId, setSLocationId] = useState('')
        const [sStatus, setSStatus] = useState('')
        
        const [attendanceList, setAttendanceList] = useState([])
        const [payMonth, setPayMonth] = useState('')
        
        
        const [userId, setUserId] = useState('')
        const [username, setUsername] = useState('')
        const [isEdit, setIsEdit] = useState(false)

        const [statusOptions, setStatusOptions]     = useState(['Present', 'Absent', 'Leave', 'Holiday'])
        const [modal_attendance, setmodal_attendance] = useState(false);

        const [employeeOptions, setEmployeeOptions] = useState([])
        const [locationList, setLocationList] = useState([])
        const [depts, setDepts] = useState([])

        const employeeOptionsRef = useRef([]);
        
        const removeBodyCss = () => {
          document.body.classList.add("no_padding");
        }
        const tog_attendance = () => {
          setmodal_attendance(!modal_attendance);
          removeBodyCss();
        }
        const fetchData = async () => {
            try {
                setIsLoading(true)
                const locationsResponse = await axios.get(url.HRLOCATIONS, Config);
                setLocationList(locationsResponse.data);
                const deptsResponse = await axios.get(url.DEPTS, Config);
                setDepts(deptsResponse.data);
                const data = {status:'Active'}
                const em = await axios.post(`${url.HREMPLOYEESFILTER}`, JSON.stringify(data), Config)
                let arr = []; (em.data || []).map((a)=>{ arr.push({'value':a.id, 'label':a.name}) })
                setEmployeeOptions(arr)
                employeeOptionsRef.current = arr; 
            } catch(e){
                console.log(e)
            } finally {
                setIsLoading(false)
            }
            handleFilterData();
        }
        
        useEffect(() => {
          if (localStorage.getItem("authWTUser")) {
            const obj = JSON.parse(localStorage.getItem("authWTUser"));
            setUserId(obj.id);
            setUsername(obj.username)
          }
          fetchData() 
        },[]);

        
        
        const handleFilterData = async () =>{
          const data = {
            id          : '',
            employeeName: sEmployeeName,
            startDate   : formatDate(sStartDate),
            endDate     : formatDate(sEndDate),
            deptId      : sDeptId,
            locationId  : sLocationId,
            status      : sStatus
         }
         try {
          setIsLoading(true)
          const r = await axios.post(url.HRATTENDANCEFILTER, JSON.stringify(data), Config)
          setAttendanceList(r.data)
         } catch (e) {
          console.log(e)
         } finally {
          setIsLoading(false)
         }
        }
        const handleClearSearch = () =>{
          setId('')
          setSEmployeeName('')
          setSStartDate([new Date()])
          setSEndDate([new Date()])
          setSLocationId('')
          setSDeptId('')
          setSStatus('')
          handleFilterData()
        }

        const handleClickAdd = () =>{
          setIsEdit(false)
          if (localStorage.getItem("authWTUser")) {
            const obj = JSON.parse(localStorage.getItem("authWTUser"));
            setUserId(obj.id);
            setUsername(obj.username)
          }
          setSelectedEmployee(null)
          setADate([])
          setStatus('')
          tog_attendance()
        }

        const handleSaveAttendance = async () =>{
          const data = {
            id            : isEdit?id:'',
            employee_id   : selectedEmployee.value,
            date          : formatDate(aDate),
            status        : status,
            recorded_by   : userId,
            action        : isEdit?"edit":"add"
          }
          try {
            setIsLoading(true)
            const r = await axios.post(url.HRATTENDANCE, JSON.stringify(data), Config)
            if(r.data.status == 1){
              toastr.success(r.data.message)
              setSelectedEmployee(null)
              setId('')
              setADate([])
              setStatus('')
              tog_attendance()
              handleFilterData()
            }else{
              toastr.error(r.data.message)
            }
          } catch (e) {
            console.log(e)
          } finally {
            setIsLoading(false)
          }
        }


        const pageOptions = {
          sizePerPage: 10000,
          totalSize: attendanceList.length,
          custom: true,
        }
        var node = useRef();
              
        const columns = [
        {
          dataField: 'emp_number',
          text: 'No',
          sort: true
        },
        {
          dataField: 'first_name',
          text: 'Name',
          sort: true,
          formatter: nameFormatter,
        },
        {
          dataField: 'department',
          text: 'Department',
          sort: true
        },
        {
          dataField: 'location',
          text: 'Location',
          sort: true
        },
        {
          dataField: 'date',
          text: 'Date',
          sort: true
        },
        {
          dataField: 'recorded_by_username',
          text: 'Processed By',
          sort: true
        }, 
        {
          dataField: 'created_at',
          text: 'Recorded On',
          sort: true
        }, 
        {
          dataField: 'status',
          text: 'Status',
          sort: true,
          formatter: statusFormatter
        },
        {
          dataField: "action",
          isDummyField: true,
          text: "",
          formatter: actionFormatter
        }];

        const defaultSorted = [{
          dataField: 'dateTime',
          order: 'desc'
        }];
 
         function nameFormatter(cellContent, row) {
          const formatted = row.first_name + ' ' + row.middle_name + ' ' + row.surname;
          return (
            <div>
              {formatted}
            </div>
          );
        }
 
        function actionFormatter(cellContent, row){
          return(
            <Button
                  type="button"
                  color="info"
                  className="btn-sm btn-rounded"
                  onClick={()=>{ 
                      setIsEdit(true)
                      tog_attendance()
                      setSelectedEmployee(employeeOptionsRef.current.find(opt => parseInt(opt.value) == row.employee_id));
                      setADate([new Date(row.date)])
                      setStatus(row.status)
                      setUsername(row.recorded_by_username)
                      setId(row.aid)
                    }
                  }
                >
                  Details
            </Button>
          )
        }
        function statusFormatter(cellContent, row) {
          if (cellContent == "Present") {
            return (
              <div>
                  <Badge className="me-2 bg-success">{ cellContent }</Badge>
              </div>
            );
          }else if(cellContent == "Leave"){
            return (
              <div>
                  <Badge className="me-2 bg-warning">{cellContent}</Badge>
              </div>
            );
          }else if(cellContent == "Holiday"){
            return (
              <div>
                  <Badge className="me-2 bg-warning">{cellContent}</Badge>
              </div>
            );
          }else{
            return (
              <div>
                  <Badge className="me-2 bg-danger">{ cellContent }</Badge>
              </div>
            );
          }
        }

        
        return (
            <>
              <LoadingOverlay
                active={isLoading}
                spinner={<BounceLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Attendance | {url.COMPANY}</title>
                    </MetaTags>
                    <Container fluid={true}>

                                <Modal isOpen={modal_attendance} toggle={() => { tog_attendance(); }}  size="l" centered  backdrop={'static'}  >
                                <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{isEdit?`Update`:`Add`} Employee Attendance/Absence</h5>
                                    <button type="button"  onClick={() => { setmodal_attendance(false);  }}  className="close" data-dismiss="modal"aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <Row>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Employee Name</label>
                                                <Select value={selectedEmployee} onChange={(oo)=>{setSelectedEmployee(oo);  }} options={employeeOptions} isSearchable/>
                                            </div>
                                        </Col>
                                      <Col md={12}>
                                          <div className="mb-3">
                                              <label>Date</label>
                                              <Flatpickr
                                                    className="form-control"
                                                    options={{
                                                    dateFormat: "Y-m-d", 
                                                    enableTime: false,
                                                    locale: {
                                                        firstDayOfWeek: 1, 
                                                    },
                                                    }}
                                                    value={aDate}
                                                    onChange={(dates) => setADate(dates[0])}
                                                />
                                          </div>
                                      </Col>
                                      <Col md={12}>
                                          <div className="mb-3">
                                              <label>Status</label>
                                              <select className="form-select" value={status} onChange={(e)=>setStatus(e.target.value)} >
                                              <option value=""></option>
                                                    {statusOptions.map((a,k)=>(
                                                        <option key={k} value={a}>{a}</option>
                                                    ))}
                                              </select>
                                          </div>
                                      </Col>
                                   
                                    <Col md={12}>
                                          <div className="mb-3">
                                              <label>Processed By</label>
                                              <input className='form-control' type='text' defaultValue={username} disabled={true}/>
                                          </div>
                                      </Col>
                                   
                                    </Row>
                                </div>
                                <div className="modal-footer">
                                {isLoading ? 
                                        (<button type="button" className="btn btn-secondary" disabled={true}>Please wait...</button>)
                                    : ( <button type="button" className="btn btn-success" onClick={handleSaveAttendance} >Save...</button> )
                                }</div>
                                </Modal> 

                            <Row>
                                      
                            <Col lg="12">
                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">Filter</h5>
                                <CardBody>
                                <div>
                                    <Row className="mb-3">
                               

                                    
                                    </Row>
                                </div>
                                                <Row className="justify-content-center mb-1">
                                                    <Col xl={2}>
                                                        <div className="mb-3">
                                                            <label>Employee Name</label>
                                                            <input className='form-control form-control-sm' type='text' value={sEmployeeName} onChange={(e) => setSEmployeeName(e.target.value)} />
                                                        </div>
                                                    </Col>
                                                    <Col xl={2}>
                                                        <div className="mb-3">
                                                            <label>Start Date</label>
                                                            <Flatpickr
                                                                className="form-control form-control-sm"
                                                                options={{
                                                                dateFormat: "Y-m-d",
                                                                enableTime: false,
                                                                locale: {
                                                                    firstDayOfWeek: 1, 
                                                                },
                                                                }}
                                                                value={sStartDate}
                                                                onChange={(dates) => setSStartDate(dates[0])}
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col xl={2}>
                                                        <div className="mb-3">
                                                            <label>End Date</label>
                                                            <Flatpickr
                                                                className="form-control form-control-sm"
                                                                options={{
                                                                dateFormat: "Y-m-d",
                                                                enableTime: false,
                                                                locale: {
                                                                    firstDayOfWeek: 1, 
                                                                },
                                                                }}
                                                                value={sEndDate}
                                                                onChange={(dates) => setSEndDate(dates[0])}
                                                            />
                                                        </div>
                                                    </Col>
                                                   <Col md={2}>
                                                        <div className="mb-3">
                                                            <label>Department</label>
                                                            <select className="form-select form-select-sm" value={sDeptId} onChange={(e)=>setSDeptId(e.target.value)}>
                                                            <option value="">All</option>
                                                            {depts.map((d,k)=>(
                                                                <option key={k} value={d.id}>{d.name}</option>
                                                            ))}
                                                        </select>
                                                        </div>
                                                    </Col>
                                                    <Col md={2}>
                                                        <div className="mb-3">
                                                            <label>Location</label>
                                                            <select className="form-select form-select-sm" value={sLocationId} onChange={(e)=>setSLocationId(e.target.value)}>
                                                            <option value="">All</option>
                                                            {locationList.map((d,k)=>(
                                                                <option key={k} value={d.id}>{d.name}</option>
                                                            ))}
                                                        </select>
                                                        </div>
                                                    </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Status</label>
                                                          <select className="form-select form-select-sm" value={sStatus} onChange={(e)=>setSStatus(e.target.value)}>
                                                              <option value="">All</option>
                                                              {(statusOptions || []).map((e,k)=>(
                                                                <option value={e} key={k}>{e}</option>
                                                              ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                </Row>
                             
                                                <Row  className="justify-content-center mb-2">
                                                <Col lg={2} className='mb-2'> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='primary'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleFilterData()}}
                                                      >
                                                        <i className="mdi mdi-magnify me-1" />
                                                        Search
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                  <Col lg={2} className='mb-2'> 
                                                    <div className="d-grid gap-2">
                                                      <Button
                                                        color='warning'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleClearSearch()}}
                                                      >
                                                        <i className="mdi mdi-notification-clear-all me-1" />
                                                        Reset search
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                  <Col lg={2} className='mb-2'> 
                                                    <div className="d-grid gap-2">
                                                      <Button
                                                        color='success'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleClickAdd()}}
                                                        
                                                      >
                                                        <i className="mdi mdi-plus me-1" />
                                                        Record Attendane/Absence
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                </Row>
                                                </CardBody>
                                                </Card>
                                                <Card>
                                                <h5 className="card-header bg-transparent border-bottom text-uppercase">Attendance ({attendanceList.length})</h5>
                                                  <CardBody>

                                                                                             
                                {(attendanceList.length > 0) && (
                                    <PaginationProvider
                                    pagination={paginationFactory(pageOptions)}
                                    keyField="aid"
                                    columns={columns}
                                    data={attendanceList}
                                    >
                                    {({ paginationProps, paginationTableProps }) => (
                                    <ToolkitProvider
                                      keyField="aid"
                                      data={attendanceList}
                                      columns={ columns }
                                    >
                                      { toolkitProps => (
                                          <React.Fragment>
                              
                                            <Row>
                                              <Col xl="12">
                                                
                                              <div className="table-responsive">
                                                <BootstrapTable 
                                                  keyField='aid' 
                                                  data={attendanceList} 
                                                  columns={ columns } 
                                                  striped
                                                  hover
                                                  condensed
                                                  bordered={false}
                                                  noDataIndication="No Records" 
                                                  defaultSorted={ defaultSorted }
                                                  classes={ "table table-sm align-middle table-nowrap table-check" }
                                                  style={{ backgroundColor: 'white' }}
                                                    {...toolkitProps.baseProps}
                                                    {...paginationTableProps}
                                                  ref={node}
                                                  />
                                                  </div>
                                            
                                            </Col>
                                            </Row>
                                            <Row className="align-items-md-center mt-30">
                                              <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                                <PaginationListStandalone
                                                  {...paginationProps}
                                                />
                                              </Col>
                                            </Row>
                                            </React.Fragment>
                                            
                                      )
                                    }
                                    </ToolkitProvider>
                                    )}
                                    </PaginationProvider>
                                    )}
                                    {((attendanceList || []).length < 1) && (
                                    <div className="text-center">
                                      <div className="mb-4">
                                      <i className="mdi mdi-flask-empty-minus-outline text-danger display-4" />
                                      </div>
                                      <div>
                                      { isLoading ? <h5>Please Wait...</h5> : <h5>No data</h5> }
                                      <p className="text-muted">
                                              
                                      </p>
                                      </div>
                                      <div className="text-center mt-4">
                                        <Link
                                        to="#"
                                        onClick={()=>{handleClickAdd()}}
                                       
                                        className="btn btn-primary  btn-sm"
                                        >
                                        Record Attendane/Absence <i className="mdi mdi-arrow-right ms-1" />
                                        </Link>
                                    </div>
                                    </div>
                                    

                                    )}


                                </CardBody>
                            </Card>
                            </Col>

                           
                        </Row>

                        
                           

                    </Container>
                </div>
                </LoadingOverlay>
            </>
        );
    }

export default Attendance;